import _regeneratorRuntime from "/nerv.app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/nerv.app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.json.stringify.js";
import Dialog from "../components/Dialog.vue";
import snoreSettingMixin from "../mixins/snoreSettingMixin";
import { setSnoreSettingInfos } from "../../../utils/api";
import noNetTip from "../../components/NoNetTip/index.vue";
import { getPackageName } from "../../../utils/native";
export default {
  name: "snoreData",
  components: {
    noNetTip: noNetTip,
    Dialog: Dialog
  },
  data: function data() {
    return {
      isCn: true,
      checked: '',
      storageMethod: 1,
      storageDuration: 1,
      activeIcon: require('../../../assets/imgs/snore/checked.png'),
      inactiveIcon: require('../../../assets/imgs/snore/uncheck.png'),
      methodsDialogShow: false,
      durationDialogShow: false,
      hideStorageMethodEntry: false
    };
  },
  mixins: [snoreSettingMixin],
  computed: {
    storageDurationText: function storageDurationText() {
      //console.log('days', this.days)
      var text = this.days > 1 ? this.days + this.$t('message.snore.days') : this.days + this.$t('message.snore.day'); // console.log('days', this.days > 1, text)

      return text;
    },
    showVipDays: function showVipDays() {
      if (this.hideStorageMethodEntry) {
        if (this.flag == 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  },
  beforeCreate: function beforeCreate() {
    document.title = this.$t("message.snore.snoreRecordSetting"); // 标题国际化
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var package_name, androidPublicPackageLists, iosPublicPackageLists, isiOS;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getPackageName();

            case 2:
              package_name = _context.sent;
              // android 和ios 需要隐藏云端存储入口的包名
              androidPublicPackageLists = ['com.mobvoi.companion.openaw'];
              iosPublicPackageLists = ["public://", 'com.mobvoi.public'];
              isiOS = sessionStorage.getItem('isiOS') === 'true' ? true : false;

              if (!isiOS) {
                _this.hideStorageMethodEntry = androidPublicPackageLists.findIndex(function (item) {
                  return item === package_name;
                }) !== -1;
              } else {
                _this.hideStorageMethodEntry = iosPublicPackageLists.findIndex(function (item) {
                  return item === package_name;
                }) !== -1;
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    toDetail: function toDetail(type) {
      this.activeName = type;

      if (type === 'location') {
        if (!this.hideStorageMethodEntry) {
          this.methodsDialogShow = true;
        }
      } else {
        this.durationDialogShow = true;
      }
    },
    clickMask: function clickMask() {
      this.methodsDialogShow = false;
      this.durationDialogShow = false;
    },
    changeType: function changeType(type) {
      var _this2 = this;

      var needShowVipDialog = this.getIsNeedVipDialog(type, 'location');

      if (type === 'cloud' && needShowVipDialog) {
        this.showVipDialog();
        this.type = this.lastedCheckedType;
      } else {
        this.type = type;
        var value = Object.assign({}, this.settingDetails, {
          type: type,
          days: this.days
        });
        var data = {
          "type": "snore_store",
          "value": JSON.stringify(value)
        };
        this.methodsDialogShow = false;
        setSnoreSettingInfos(data).then(function (res) {
          // console.log(res)
          if (res) {
            _this2.type = type;
            _this2.lastedCheckedType = type;
          } else {
            _this2.type = _this2.lastedCheckedType;
          }
        }).catch(function (e) {
          _this2.type = _this2.lastedCheckedType;
        });
      }
    },
    changeDays: function changeDays(days) {
      var _this3 = this;

      var needShowVipDialog = this.getIsNeedVipDialog(days, 'duration');

      if ((days === 30 || days === 180) && needShowVipDialog) {
        this.showVipDialog();
        this.days = this.lastedCheckedDays; // console.log('显示村粗时长弹窗', this.lastedCheckedDays)
      } else {
        this.days = days;
        var value = Object.assign({}, this.settingDetails, {
          type: this.type,
          days: days
        });
        var data = {
          "type": "snore_store",
          "value": JSON.stringify(value)
        };
        this.durationDialogShow = false;
        setSnoreSettingInfos(data).then(function (res) {
          if (res) {
            _this3.days = days;
            _this3.lastedCheckedDays = days;
          } else {
            _this3.days = _this3.lastedCheckedDays;
          }
        }).catch(function (e) {
          _this3.days = _this3.lastedCheckedDays;
        });
      }
    }
  }
};